var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Allows the user to select the glazing type associated with the damaged window pane.
 * touches: declaration, externalDamage, windowDamage
 * invariants: The selected glazing type remains synchronized with the current window damage data.
 * inputs: available glazing type choices and user selection.
 * outputs: updates the window pane glazing type through the parent component.
 * see: @declaration/components/externalDamage/DamageDescription/Window/Window.vue
 */
import { Component } from 'vue-property-decorator';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import { WINDOW_PANE_GLAZING_TYPE_TITLE, WINDOW_PANE_GLAZING_TYPE_CHOICES, } from '@shared/constants/externalDamages';
import { WindowComponent } from '@declaration/components/externalDamage/DamageDescription/Window/WindowComponent';
let WindowPaneGlazingType = class WindowPaneGlazingType extends WindowComponent {
    get windowPaneGlazingTypeTitle() {
        return this.translateExternalDamageKey(WINDOW_PANE_GLAZING_TYPE_TITLE);
    }
    get windowPaneGlazingTypeChoices() {
        return WINDOW_PANE_GLAZING_TYPE_CHOICES;
    }
    get uiWindowPaneGlazingTypeChoices() {
        return this.windowPaneGlazingTypeChoices.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
};
WindowPaneGlazingType = __decorate([
    Component({ components: { UiRadio, UiCard } })
], WindowPaneGlazingType);
export default WindowPaneGlazingType;
